import { createSlice } from "@reduxjs/toolkit";
import { ProfileState } from "./profile";

const initialState: ProfileState = {
  theme: undefined,

  status: "idle",
  error: undefined,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
  },
  extraReducers() {},
});

// Action creators are generated for each case reducer function

export const { setTheme } = profileSlice.actions;

export default profileSlice.reducer;
